/**
 * useAccountSwitcher — shared singleton signal for opening/closing the account
 * switcher overlay.
 *
 * Comandero mounts the sidebar twice (mobile drawer + desktop rail). A
 * module-level singleton (mirroring `useSearchPalette`) lets every trigger flip
 * the same open state while a single `<AccountSwitcherHost>` renders the overlay
 * once — so we never stack two dialogs that would swallow each other's clicks.
 */

import { createSignal } from "solid-js";

const [isOpen, setIsOpen] = createSignal(false);

interface AccountSwitcherControls {
  isOpen: () => boolean;
  open: () => void;
  close: () => void;
  setOpen: (open: boolean) => void;
}

export function useAccountSwitcher(): AccountSwitcherControls {
  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    setOpen: (open: boolean) => setIsOpen(open),
  };
}
